var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CustomModal', {
    attrs: {
      "name": "sizeSelectionModal",
      "customClass": "generic-modals v--modal new-modal",
      "width": "75%",
      "height": "auto",
      "maxWidth": 500,
      "clickToClose": false,
      "customRef": "sizeSelectionModal"
    },
    on: {
      "closed": _vm.resetSelectField
    }
  }, [_c('CustomContainer', {
    attrs: {
      "customClass": "new-modal-wrapper customs-tools",
      "elementType": "section"
    }
  }, [_c('ModalHeader', {
    attrs: {
      "backDisabled": true,
      "closeDisabled": true,
      "headerImg": true,
      "includeClose": false,
      "includeBack": false
    }
  }), _c('CustomContainer', {
    staticClass: "new-modal-main-views-wrapper new-size-selection-content",
    attrs: {
      "elementType": "section"
    }
  }, [_c('CustomText', {
    attrs: {
      "elementType": "h2",
      "customClass": "text-center new-size-selection-title",
      "keyTranslation": "sizeSelectionHeader"
    }
  }), _c('SizeSelectionContent', {
    ref: "sizeSelectionContent",
    on: {
      "blockCtaPrimaryButton": _vm.blockCtaPrimaryButton
    }
  })], 1), _c('CustomContainer', {
    staticClass: "new-modal-button-nav"
  }, [_c('CustomContainer', {
    staticClass: "new-modal-button-nav-container"
  }, [_c('CustomButton', {
    attrs: {
      "customClass": "new-modal-button-nav-container-cta expanded primary",
      "isDisabled": _vm.disabledCta,
      "keyTranslation": "sizeSelectionContinue",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$refs.sizeSelectionContent.onContinue();
      }
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }